import { h } from 'preact';
export const Lock = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("rect", { x: "3", y: "11", width: "18", height: "11", rx: "2", ry: "2" }),
        h("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })));
};
//# sourceMappingURL=lock.js.map